<template>
  <svg
    :class="['icon', getNameAsValidId(icon)]"
    xmlns="http://www.w3.org/2000/svg"
    :width="dimension"
    :height="dimension"
    :viewBox="viewBox"
    :aria-label="ariaLabel"
    :aria-labelledby="ariaLabelledby"
  >
    <title
      v-if="name"
      :id="getNameAsValidId(name)"
      lang="en"
    >{{ name }}</title>
    <g fill="none" :stroke="color">
      <slot v-if="$slots.default" />
      <component v-else :is="icon" />
    </g>
  </svg>
</template>

<script>
import { computed } from 'vue';
import * as iconComponents from '@/components/icons/components';
import { iconViewBoxes } from '@/components/icons/viewbox';

export default {
  name: 'IconBase',
  components: {
    ...iconComponents,
  },
  props: {
    icon: {
      type: String,
    },
    name: {
      type: String,
    },
    ariaLabel: {
      type: String,
      default: 'icon',
    },
    size: {
      type: String,
      default: 'medium',
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
  setup(props) {
    const defaultViewBox = '0 0 32 32';
    const viewBox = iconViewBoxes[props.icon] ?? defaultViewBox;

    const dimension = computed(() => {
      switch (props.size) {
        case 'small':
          return 20;
        case 'medium':
          return 28;
        case 'large':
          return 32;
        default:
          return 24;
      }
    });

    const getNameAsValidId = (name) => name?.toLowerCase().replace(/ /g, '-');

    const ariaLabelledby = computed(() => (props.name === null || props.name === ''
      ? null
      : getNameAsValidId(props.name)));

    return {
      /* Computed Properties */
      dimension,
      viewBox,
      ariaLabelledby,

      /* Methods */
      getNameAsValidId,
    };
  },
};
</script>
